import loading_animation from 'animations/tqps-loading.gif';
import React, { Component } from 'react';
import { withRouter } from 'utilities';
import { useAuth } from 'auth_context';
import CityAutocomplete from 'components/CityAutocomplete';
import OrgAutocomplete from 'components/OrgAutocomplete';

class OnboardingPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loaded: false,
			step: 0,
			phase_2_visible: false,
			show_mismatched_pw: false,
			name: '',
			org_id: null,
			joining_existing: false,
			show_create_org: false,
			org_name: '',
			org_city: '',
			org_state: '',
			org_country: '',
			org_lat: null,
			org_lng: null,
			org_email: '',
			org_address: '',
			org_website: '',
			user_email: '',
			user_phone: '',
			password1: '',
			password2: '',
		};
	}

	componentDidMount() {
		this.get_prefills();
		this.setState({ step: 1 }, () => this.setState({ loaded: true }));
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.step !== this.state.step) {
			this.handleStepEnter(this.state.step);
		}
	}

	handleStepEnter = step => {
		this.setState({ phase_2_visible: false });

		if (step === 1) {
			setTimeout(() => {
				this.setState({ phase_2_visible: true });
			}, 300);
		}

		if (step === 2) {
			setTimeout(() => {
				this.setState({ phase_2_visible: true });
			}, 800);
		}

		if (step === 3) {
			setTimeout(() => {
				this.setState({ phase_2_visible: true });
			}, 500);
		}
	};

	get_prefills = async () => {
		let response = await this.props.auth.authFetch('/api/get_prefills/');
		let data = await response.json();

		let states = [];
		let countries = [];

		for (let state of data.states) {
			states.push(<option value={state}>{state}</option>);
		}
		for (let country of data.countries) {
			countries.push(<option value={country}>{country}</option>);
		}

		this.setState({ countries: countries, states: states });
	};

	next_step = () => {
		this.setState({ loaded: false, phase_2_visible: false }, () => {
			setTimeout(() =>
				this.setState(
					prev => {
						// Skip step 3 (org contact details) when joining an existing org —
						// that org already has its details and editing is gated until approval.
						let increment = 1;
						if (prev.step === 2 && prev.joining_existing) {
							increment = 2;
						}
						return { step: prev.step + increment };
					},
					() =>
						setTimeout(() => {
							this.setState({ loaded: true });
						}, 50)
				)
			);
		});
	};

	trigger_phase2 = time => {
		setTimeout(() => this.setState({ phase_2_visible: true }), time);
	};

	submit = async () => {
		this.props.auth.setLoading(true);

		let url = '/api/submit_new_user/';

		let form_data = {
			name: this.state.name,
			org_id: this.state.org_id,
			org_name: this.state.org_name,
			org_city: this.state.org_city,
			org_state: this.state.org_state,
			org_country: this.state.org_country,
			org_lat: this.state.org_lat,
			org_lng: this.state.org_lng,
			org_email: this.state.org_email,
			org_address: this.state.org_address,
			org_website: this.state.org_website,
			user_email: this.state.user_email,
			user_phone: this.state.user_phone,
			password: this.state.password1,
		};

		let response = await this.props.auth.authFetch(url, {
			method: 'POST',
			body: JSON.stringify(form_data),
			headers: { 'Content-Type': 'application/json' },
		});

		let data = await response.json();

		await this.props.auth.setUser(data.user);
		this.props.auth.setLoading(false);

		this.props.navigate('/org_portal');
	};

	render_page = page_num => {
		let button_visible = false;
		let visible = this.state.loaded ? 'visible' : 'invisible';
		let phase_2 = this.state.phase_2_visible ? 'visible' : 'invisible';

		if (page_num === 0) {
			return;
		} else if (page_num === 1) {
			button_visible = this.state.name !== '' ? 'visible' : 'invisible';
			return (
				<div className={`onboarding-container slow-appearing ${visible}`}>
					<h1>Welcome</h1>
					<h3>To the Constellation Network</h3>
					<br />
					<div className={`slow-appearing ${this.state.phase_2_visible ? 'visible' : 'invisible'}`}>
						<h2>What is your name?</h2>
						<input
							className="onboarding-single-line-input"
							onChange={e => this.setState({ name: e.target.value })}
						/>
						<br />
						<br />
						<button className={`appearing ${button_visible}`} onClick={this.next_step}>
							Continue
						</button>
					</div>
				</div>
			);
		} else if (page_num === 2) {
			const can_continue =
				this.state.org_id !== null || (this.state.org_name !== '' && this.state.org_city !== '');
			button_visible = can_continue ? 'visible' : 'invisible';
			return (
				<div className={`onboarding-container slow-appearing ${visible}`}>
					<h1>Hi {this.state.name}!</h1>

					<div className={`slow-appearing ${phase_2}`}>
						{!this.state.joining_existing &&
						this.state.org_id === null &&
						!this.state.show_create_org ? (
							<>
								<h3>What organization are you with?</h3>
								<div className="org-detail-table">
									<label className="org-detail-label" for="org_search">
										Find your org:
									</label>
									<OrgAutocomplete
										placeholder="Search for your organization..."
										onSelect={org =>
											this.setState({
												org_id: org.id,
												joining_existing: true,
												org_name: org.name,
												org_city: org.city || '',
												org_state: org.state || '',
												org_country: org.country || '',
												org_lat: org.lat,
												org_lng: org.lng,
												org_email: org.email || '',
												org_address: org.address || '',
												org_website: org.website || '',
											})
										}
									/>
								</div>
								<h5>
									If your organization is already in the Constellation Network, search for
									it above to request to join.
								</h5>
								<br />
								<button
									className="link-button"
									onClick={() => this.setState({ show_create_org: true })}
								>
									Can't find your organization? Create a new one
								</button>
							</>
						) : this.state.joining_existing ? (
							<>
								<h3>Requesting to join:</h3>
								<h2>{this.state.org_name}</h2>
								<h5>
									{[this.state.org_city, this.state.org_state].filter(Boolean).join(', ')}
								</h5>
								<br />
								<button
									className="link-button"
									onClick={() =>
										this.setState({
											org_id: null,
											joining_existing: false,
											show_create_org: false,
											org_name: '',
											org_city: '',
											org_state: '',
											org_country: '',
											org_lat: null,
											org_lng: null,
										})
									}
								>
									← Search for a different organization
								</button>
							</>
						) : (
							<>
								<h3>Tell us more about your organization:</h3>
								<div className="org-detail-table">
									<label className="org-detail-label" for="org_name">
										Organization name:
									</label>
									<input
										className="org-detail-input"
										id="org_name"
										value={this.state.org_name}
										onChange={e => this.setState({ org_name: e.target.value })}
									/>
								</div>
								<br />
								<CityAutocomplete
									placeholder="Search for your city..."
									onSelect={({ city, state, country, lat, lng }) =>
										this.setState({
											org_city: city,
											org_state: state,
											org_country: country,
											org_lat: lat,
											org_lng: lng,
										})
									}
								/>
								<h5>
									All info you share will be hidden from the network unless otherwise
									specified.
								</h5>
								<br />
								<button
									className="link-button"
									onClick={() => this.setState({ show_create_org: false })}
								>
									← Back to search
								</button>
							</>
						)}
						<br />
						<button className={`appearing ${button_visible}`} onClick={this.next_step}>
							Continue
						</button>
					</div>
				</div>
			);
		} else if (page_num === 3) {
			button_visible = this.state.org_name !== '' ? 'visible' : 'invisible';

			return (
				<div className={`onboarding-container slow-appearing ${visible}`}>
					<h2>How should people get in touch with {this.state.org_name}?</h2>

					<div className="org-detail-table">
						<label className="org-detail-label" for="org_email">
							{this.state.org_name} email:
						</label>
						<input
							className="org-detail-input"
							id="org_email"
							onChange={e => this.setState({ org_email: e.target.value })}
						/>
						<div />
						<label className="org-detail-label" for="org_address">
							Mailing address:
						</label>
						<input
							className="org-detail-input"
							id="org_address"
							onChange={e => this.setState({ org_address: e.target.value })}
						/>
						<div />
						<label className="org-detail-label" for="org_website">
							Website:
						</label>
						<input
							className="org-detail-input"
							id="org_website"
							onChange={e => this.setState({ org_website: e.target.value })}
						/>
						<div />
					</div>
					<div className={`slow-appearing ${phase_2}`}>
						<h5>These fields are optional.</h5>
						<button className={`appearing`} onClick={this.next_step}>
							Continue
						</button>
					</div>
				</div>
			);
		} else if (page_num === 4) {
			return (
				<div className={`onboarding-container slow-appearing ${visible}`}>
					<h2>How can we get in touch with you?</h2>
					<h5>For account updates / news about the network etc.</h5>

					<div className="org-detail-table">
						<label className="org-detail-label" for="user_email">
							Your email:
						</label>
						<input
							className="org-detail-input"
							id="user_email"
							onChange={e => this.setState({ user_email: e.target.value })}
						/>
						<div />
						<label className="org-detail-label" for="user_phone">
							Phone number:
						</label>
						<input
							className="org-detail-input"
							id="user_phone"
							onChange={e => this.setState({ user_phone: e.target.value })}
						/>
						<div />
					</div>
					<button className={`appearing`} onClick={this.next_step}>
						Continue
					</button>
				</div>
			);
		} else if (page_num === 5) {
			let passwords_match = this.state.password1 === this.state.password2;
			let password_long_enough = this.state.password1.length > 10;

			return (
				<div className={`onboarding-container slow-appearing ${visible}`}>
					<h2>Enter a strong password for your account:</h2>
					<div className="org-detail-table">
						<label className="org-detail-label" for="user_email">
							Login:
						</label>
						<h4>{this.state.user_email}</h4>
						<div></div>
						<label className="org-detail-label" for="password1">
							Password:
						</label>
						<input
							className="org-detail-input"
							type="password"
							id="password1"
							onChange={e => this.setState({ password1: e.target.value })}
						/>
						<div></div>
						<label className="org-detail-label" for="password2">
							Re-Enter Password:
						</label>
						<input
							className="org-detail-input"
							type="password"
							id="password2"
							onChange={e => this.setState({ password2: e.target.value })}
						/>
						<div></div>
						<div />
					</div>

					<button
						className={`appearing ${password_long_enough ? 'visible' : 'invisible'}`}
						onClick={() => {
							if (!passwords_match) {
								this.setState({ show_mismatched_pw: true });
							} else {
								this.setState({ show_mismatched_pw: false });
								this.submit();
							}
						}}
					>
						Continue
					</button>

					<h5 className={`appearing ${this.state.show_mismatched_pw ? 'visible' : 'invisible'}`}>
						Passwords do not match.
					</h5>
				</div>
			);
		}
	};

	render() {
		return (
			<div className="modal-overlay">
				<div key={this.state.step}>{this.render_page(this.state.step)}</div>
			</div>
		);
	}
}

const Onboarding = props => {
	const auth = useAuth();
	return <OnboardingPage {...props} auth={auth} />;
};

export default withRouter(Onboarding);
